class FeaturedFloorplans {

	constructor() {
		// view
		this.name = 'featured-floorplans';
		this.components = document.querySelectorAll(`.${this.name}`);

		if (this.components) {
			this.init();
		}
	}

	init() {
		this.components.forEach((comp) => {
			let sliderNode = comp.querySelector('.splide');
			if (!sliderNode) return;
			this.initSlider(sliderNode);
		});
	}
	initSlider = (slider) => {
		const sliderFloorplans = new Splide(slider, {
			type: 'loop',
			arrows: false,
			pagination: true,
			perPage: 1,
			gap: '2rem',
			destroy: true,
			breakpoints: {
				960: {
					destroy: false,
				},
			},
		}).mount();
	};
}
